import { store } from './../store' 

export const AGGIORNA_VERSIONI = (nomeParametro) =>{
    store.dispatch({
        type: "AGGIORNA_VERSIONI",
        payload: nomeParametro
    })
}
    